import { ApiInstance, RetrySettings } from '@src/services/api-instance';
import { getAuthToken } from '@src/services/auth-service';

export class BrainRunsService {
  private readonly client: ApiInstance;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/runs`, client.getTimeout());
  }

  async postRerun(request: { id: string; settings?: RetrySettings }): Promise<{ message: string }> {
    return (
      await this.client.post<void, { message: string }>(`${request.id}/reruns`, undefined, {
        bearerToken: await getAuthToken(),
        settings: request.settings,
      })
    ).data;
  }
}
